import { format } from "date-fns";

const StringUtils = {
    formatBRL: (valor) => {
        return new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
        }).format(valor);
    },
    formatDocumento: (documento) => {
        if (documento == null || typeof documento != "string") return documento;
        if (documento.length === 11)
            return documento.replace(
                /(\d{3})(\d{3})(\d{3})(\d{2})/g,
                "$1.$2.$3-$4"
            );
        if (documento.length === 14)
            return documento.replace(
                /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
                "$1.$2.$3/$4-$5"
            );
        return documento;
    },
    formatDateComplete: (date) => {
        return format(new Date(date), "dd/MM/yyyy HH:mm");
    },
    cutString: (text) => {
        let wordsToCut = 43;
        let wordsArray = text;
        if (wordsArray && wordsArray.length > wordsToCut) {
            let strShort = wordsArray.substring(0, wordsToCut - 3).trim();
            return strShort + "...";
        } else {
            return text;
        }
    },
};

export default StringUtils;
